import { Column } from "react-table";
import { Grid } from "../Grid";
import { SelectColumnFilter } from "../Grid/NoFetchGrid/SelectColumnFilter";
import { getIconForType } from "../icons/LeapIcons";
import { ICompliance, IComplianceList } from "../../api/ICompliance";
import { IComplianceGridProps } from "./IComplianceGridProps";
import { Link } from "react-router-dom";
import { GetComplianceRecordDetailsUrl } from "../../leap-pages/routeFactory";

const ComplianceGrid = ({
  licenceProfile,
  complianceList,
  columns,
}: IComplianceGridProps) => {
  const tableColumns: Column<Record<string, ICompliance>>[] = [
    {
      Header: "Category",
      accessor: "type",
      Filter: false,
      Cell: (rowInfo: any) => (
        <table>
          <tbody>
            <tr>
              <td style={{ paddingTop: "6px" }}>
                <span>{getIconForType(rowInfo.value)}</span>
              </td>
              <td>{rowInfo.value}</td>
            </tr>
          </tbody>
        </table>
      ),
    },
    {
      Header: "Reference No.",
      accessor: "reference",
      Filter: false,
      Cell: (rowInfo: any) => {
        const rowData = rowInfo.data[rowInfo.row.index];
        return (
          <Link
            to={GetComplianceRecordDetailsUrl(
              rowData.compliancerecord_id,
              rowData.type,
              licenceProfile.profileNo
            )}
          >
            {rowInfo.value}
          </Link>
        );
      },
    },
    {
      Header: "Subject",
      accessor: "subject",
    },
    {
      Header: "Status",
      accessor: "status",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
    {
      Header: "Date",
      accessor: "date",
      Filter: false,
    },
  ];

  if (!columns) columns = tableColumns;
  return <Grid columns={tableColumns} data={complianceList.list} />;
};

export default ComplianceGrid;
